'use client'

import { Button, Card, Stack, Text, Image } from '@vinted/web-ui'

import { AcceptedOfferWidgetModel, clickEvent } from '@marketplace-web/home/home-page-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useBreakpoint } from '@marketplace-web/breakpoints/breakpoints-feature'

import HomepageBlockLayout from '../Layouts/HomepageBlockLayout'
import BlockArrangement from '../../common/BlockArrangement'
import DynamicSpacer from '../../common/DynamicSpacer'
import InformationBreakdown from './InformationBreakdown'

type Props = AcceptedOfferWidgetModel & {
  position: number
  homepageSessionId: string
}

const AcceptedOfferWidget = (props: Props) => {
  const { track } = useTracking()
  const breakpoints = useBreakpoint()

  const trackCtaClick = () => {
    track(
      clickEvent({
        target: 'homepage_accepted_offer_widget_cta',
        targetDetails: JSON.stringify({
          homepage_session_id: props.homepageSessionId,
          item_id: props.item.id,
        }),
      }),
    )
  }

  return (
    <BlockArrangement
      prefix={<DynamicSpacer portables="XLarge" desktops="X2Large" />}
      suffix={<DynamicSpacer portables="X2Large" desktops="X3Large" />}
    >
      <Card>
        <HomepageBlockLayout {...props} className="homepage-accepted-offer-widget">
          <Stack direction="column">
            <Text as="h2" text={props.title} type={Text.Type.Title} />
            <Text as="p" text={props.subtitle} type={Text.Type.Subtitle} />
          </Stack>

          <Stack distribution="space-in-between" alignment="bottom">
            <Stack gap="regular">
              <div className="homepage-accepted-offer-widget__image">
                <Image
                  src={props.item.thumbnailUrl}
                  alt={props.item.title}
                  ratio="small-portrait"
                />
              </div>
              <InformationBreakdown item={props.item} />
            </Stack>

            <div className="u-flexbox u-align-items-flex-end u-fill-height">
              <Button
                url={props.cta.url}
                text={props.cta.body}
                onClick={trackCtaClick}
                styling={Button.Styling.Filled}
                inline={breakpoints.desktops}
                size={Button.Size.Medium}
              />
            </div>
          </Stack>
        </HomepageBlockLayout>
      </Card>
    </BlockArrangement>
  )
}

export default AcceptedOfferWidget
